export default __webpack_public_path__ + "assets/1.e787d46e.png";